<template>
    <div>
        <gc-menu></gc-menu>

        <div :class="getBaseClass()">

            <gc-header></gc-header>

            <router-view transition="fade" transition-mode="out-in"></router-view>

        </div>
    </div>
</template>

<script>
    
    import Vue from 'vue'
    import VueI18n from 'vue-i18n'
    import jQuery from 'jquery'
    import store from '../vuex/store'
    import { showMenu } from '../vuex/main-menu/actions'
    import { changeLanguage } from '../vuex/settings/actions'
    import { getLang } from '../vuex/settings/getters'
    import GcHeader from '../layout/GcHeader.vue'
    import GcMenu from '../layout/GcMenu.vue'
    import _ from 'lodash'

    Vue.use(VueI18n)
    Vue.config.lang = 'pt-BR';
    Vue.locale('pt-BR', require('../i18n/pt-BR.json'))
    Vue.locale('en-US', require('../i18n/en-US.json'))

    export default {
        name: 'App',
        store,
        components: { GcHeader, GcMenu },
        data () {
            return {
                meta: {
                    appName: 'Guco Agência Web',
                    title: 'Seja bem vindo!',
                    description: 'A Guco é uma agência de criação e desenvolvimento que há 10 anos vem criando as melhores soluções para a web',
                    image: 'http://www.guco.com.br/static/guco-social.png',
                    pageUrl: 'http://www.guco.com.br',
                    fbAppId: 1719691018282731,
                }
            }
        },
        head: {
            title () {
                return {
                    inner: this.meta.title
                }
            },
            meta () {
                return {
                    // Basic meta
                    name: {
                        'application-name': this.meta.appName,
                        'description' : this.meta.description,
                        // Twitter
                        'twitter:title': this.meta.title + ' | ' + this.meta.appName,
                        'twitter:description': this.meta.description,
                        'twitter:image': this.meta.image
                    },
                    // Google+ / Schema.org
                    itemprop: {
                        name: this.meta.title + ' | ' + this.meta.appName,
                        description: this.meta.description,
                        image: this.meta.image
                    },
                    // Facebook / Open Graph
                    property: {
                        'fb:app_id': this.meta.fbAppId,
                        'og:url': this.meta.pageUrl,
                        'og:title': this.meta.title + ' | ' + this.meta.appName,
                        'og:description': this.meta.description,
                        'og:image': this.meta.image
                    }
                }
            },
            link () {
                return {
                    canonical: {
                        href: this.meta.pageUrl
                    },
                }
            }
        },
        vuex: {
            actions: {
                showMenu,
                changeLanguage
            },
            getters: {
                getLang
            }
        },
        created () {
            this.checkLanguage();
        },
        methods: {
            getBaseClass () {
                return 'header_' + this.$route.name
            },
            checkLanguage () {
                let lsLang = localStorage.getItem('app_lang');

                if(_.isNil(lsLang))
                    this.changeLanguage('pt-BR');
                else
                    this.changeLanguage(lsLang);
            }
        }
    }
</script>

<style lang="sass">
    @import '../assets/sass/app.scss'
</style>



// WEBPACK FOOTER //
// App.vue?04bdcc1c